<template>
  <div
    class="--env --ltr --light b rlt"
    :data-open-menu="!!isMenuOpen"
    :data-ready="!!isPageReady"
  >
    <div class="fxd .s .t h-vh -z-2" style="color: white">
      <div
        class="logo-box -i-bg fxd -z-3 >"
        :style="{
          backgroundImage: 'url(' + require('@/assets/applogo.svg') + ')',
        }"
      ></div>

      <div class="loading abs .s .t">
        <div class="loading-box h-vh c-s >"></div>
        <img
          src="@/assets/SVG/paint.svg"
          class="abs h-f .s-f .t -pe-n"
          style="margin: -2px"
        />
      </div>
      <div class="menu-box h-vh c-s -o-h >">
        <div
          class="menu-container-box h-f b-cl b-j-sb -o-y-a"
          style="width: 300px; max-width: 100vw"
        >
          <div class="b-cl">
            <div class="unt h-9 w-10 b-fs -i-bg"></div>
            <a
              href="#!"
              class="unt h-9"
              @click="isMenuOpen = !isMenuOpen"
            >
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + (!isMenuOpen?require('@/assets/SVG/menu.svg'):require('@/assets/SVG/menu_close.svg')) + ')',
                }"
              ></div>
              <span class="CASE p-t-4">{{ isMenuOpen?'close menu':'open menu' }}</span>
            </a>
            <a href="#!" class="unt h-9 CASE s-d">
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/search.svg') + ')',
                }"
              ></div>
              <span class="CASE p-t-4">search</span>
            </a>
          </div>
          <div class="b-cl">
            <a href="tel:0560364030" class="unt h-9 CASE">
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/whatsapp.svg') + ')',
                }"
              ></div>
              <span class="b-fg t-b1 p-t-2"
                >whatsapp
                <div class="t-c o-5">Contact us</div></span
              >
              <div
                class="u-10 o-5 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/open.svg') + ')',
                }"
              ></div>
            </a>

            <a
              href="https://www.facebook.com/StarPeintureRoumani/"
              target="_blank"
              class="unt h-9 CASE"
            >
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/facebook.svg') + ')',
                }"
              ></div>
              <span class="b-fg t-b1 p-t-2"
                >facebook
                <div class="t-c o-5">follow us</div></span
              >
              <div
                class="u-10 o-5 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/open.svg') + ')',
                }"
              ></div>
            </a>

            <a
              href="https://www.instagram.com/star_peinture/"
              target="_blank"
              class="unt h-9 CASE"
            >
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/instagram.svg') + ')',
                }"
              ></div>
              <span class="b-fg t-b1 p-t-2"
                >instagram
                <div class="t-c o-5">follow us</div></span
              >
              <div
                class="u-10 o-5 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/open.svg') + ')',
                }"
              ></div>
            </a>
            <a
              href="https://www.messenger.com/t/1558616247543701"
              target="_blank"
              class="unt h-9 CASE"
            >
              <div
                class="h-9 w-10 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/messenger.svg') + ')',
                }"
              ></div>
              <span class="b-fg t-b1 p-t-2"
                >messenger
                <div class="t-c o-5">follow us</div></span
              >
              <div
                class="u-10 o-5 b-fs -i-bg"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/SVG/open.svg') + ')',
                }"
              ></div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="w-10"></div>
    <div class="rlt w-f h-vh -o-h">
      <div @click="isMenuOpen=!isMenuOpen" :class="(isMenuOpen?'o-8':'o-n -pe-n')+' > abs -z-1 .f c-s'"></div>
    <div :class="(isMenuOpen?'-obj-bg':'')+' > w-f h-vh -o-y-a d20 l19 c0-t'">
      <header id="welcome" class="g c-20 rlt">
        <img
          loading="lazy"
          src="@/assets/SVG/paint-x-white.svg"
          class="abs .b w-f -z"
        />
        <div class="h-vh x12 l:x6 rlt">
          <div>
            <img
              :class="'>' + (activeSideImageId == 1 ? '' : ' o-n')"
              src="@/assets/img/1000w/bg-1@1000x-80-min.webp"
              class="abs .f -obj-cv"
            />
            <img
              :class="'>' + (activeSideImageId == 2 ? '' : ' o-n')"
              src="@/assets/img/1000w/bg-2@1000x-80-min.webp"
              class="abs .f -obj-cv"
            />
            <img
              :class="'>' + (activeSideImageId == 3 ? '' : ' o-n')"
              src="@/assets/img/1000w/bg-3@1000x-80-min.webp"
              class="abs .f -obj-cv"
            />
            <img
              :class="'>' + (activeSideImageId == 4 ? '' : ' o-n')"
              src="@/assets/img/1000w/bg-4@1000x-80-min.webp"
              class="abs .f -obj-cv"
            />
          </div>
          <img
            loading="lazy"
            src="@/assets/img/SVG/img-1.svg"
            class="abs .f -obj-cn"
          />

          <img
            loading="lazy"
            src="@/assets/SVG/divider.svg"
            class="abs .e h-f"
            style="margin: 0 -1px;"
          />
        </div>
        <div class="h-vh x12 l:x6 rlt">
          <img
            loading="lazy"
            src="@/assets/img/1000w/img-2-min.webp"
            class="abs .f -obj-cn"
          />
        </div>
      </header>
      <section id="categoreis" class="c-20">
        <div class="p-y-5">
          <div
            :style="{
              backgroundImage:
                'url(' + require('@/assets/SVG/titles-bg.svg') + ')',
            }"
            class="subtitle h-12 b-c b-fs -i-bg CASE"
          >
            <b>c</b>ategoreis
          </div>
        </div>
        <SwpWidget class="p-x-7 b -o-x-a">
          <CateCard
            class="m-t-6"
            link="//starpeinture.com/products/1"
            name="industrie"
            :photo="require('@/assets/img/1000w/bg-1@1000x-80-min.webp')"
          ></CateCard>
          <CateCard
            class=""
            link="//starpeinture.com/products/2"
            name="boiserie"
            :photo="require('@/assets/img/1000w/bg-2@1000x-80-min.webp')"
          ></CateCard>
          <CateCard
            class="m-t-6"
            link="//starpeinture.com/products/3"
            name="bâtiment"
            :photo="require('@/assets/img/1000w/bg-3@1000x-80-min.webp')"
          ></CateCard>
          <CateCard
            class=""
            link="//starpeinture.com/products/4"
            name="décoration"
            :photo="require('@/assets/img/1000w/bg-4@1000x-80-min.webp')"
          ></CateCard>
          <div class="p-5 b-fs m-t-6">
            <a
              href="//starpeinture.com/explore"
              target="_blank"
              class="unt b-c crd e-4 h:e-8 rlt -o-h -r-4 w-15 10/16 scale-down-on-hover c-s"
            >
              <img
                class="abs .c"
                src="@/assets/SVG/open.svg"
                alt=""
                srcset=""
              />
              <div class="p-6 c-20-t abs .b .s">
                <div class="o-5">MORE</div>
                <div style="font-size: 30px; font-weight: bold" class="o-9">
                  — EXPLORE
                </div>
              </div>
            </a>
          </div>
        </SwpWidget>
      </section>
      <section id="wonder" class="> c-s rlt -o-h">
        <img
          src="@/assets/img/wonder/bdns4.webp"
          class="abs .t .s -obj-cv o-5"
          style="mix-blend-mode: color-dodge"
        />
        <img
          src="@/assets/img/wonder/bdns4.webp"
          class="abs .t .s -obj-cv"
          style="mix-blend-mode: luminosity"
        />
        <img
          src="@/assets/SVG/paint-x-white.svg"
          class="abs .t w-f -z -pe-n"
          style="margin: -3px 0; transform: scale(-1)"
        />
        <img
          src="@/assets/SVG/paint-x-white.svg"
          class="abs .b w-f -z -pe-n"
          style="margin: -3px 0"
        />
        <div class="g rlt p-y-12">
          <div class="x12 l:x6 b-cl b-c m-s-a">
            <img
              loading="lazy"
              class="w-16"
              src="@/assets/img/wonder-white-logo.webp"
            />
            <img loading="lazy" class="w-8" src="@/assets/SVG/next.svg" />

            <div class="subtitle h-12 b-c b-fs -i-bg c-20-t">
              by<b>→STARPEINTURE</b>
            </div>
            <div
              onclick="window.pops.show('Camming soon...')"
              class="unt btn btn-n -b -b-2 c-p-t"
            >
              DOWNLOAD CATALOG
            </div>
          </div>
        </div>
      </section>
      <section id="products" class="c-20">
        <div class="p-y-5">
          <div
            :style="{
              backgroundImage:
                'url(' + require('@/assets/SVG/titles-bg.svg') + ')',
            }"
            class="subtitle h-12 b-c b-fs -i-bg CASE"
          >
            <b>p</b>roducts
          </div>
        </div>
        <SwpWidget class="p-x-7 b -o-x-a">
          <ProductCard
            class="m-t-6"
            link="//starpeinture.com/products/1"
            name="ecowal"
            :photo="require('@/assets/temp/products/ecowall.webp')"
          ></ProductCard>
          <ProductCard
            class=""
            link="//starpeinture.com/products/2"
            name="extra"
            :photo="require('@/assets/temp/products/extra.webp')"
          ></ProductCard>
          <ProductCard
            class="m-t-6"
            link="//starpeinture.com/products/3"
            name="fixastar"
            :photo="require('@/assets/temp/products/fixastar.webp')"
          ></ProductCard>
          <ProductCard
            class=""
            link="//starpeinture.com/products/4"
            name="klassikt"
            :photo="require('@/assets/temp/products/klassikt.webp')"
          ></ProductCard>
          <div class="p-5 b-fs m-t-6">
            <a
              href="//starpeinture.com/explore"
              target="_blank"
              class="unt b-c crd e-4 h:e-8 rlt -o-h -r-4 w-15 1/1 scale-down-on-hover c-s"
            >
              <img
                class="abs .c"
                src="@/assets/SVG/open.svg"
                alt=""
                srcset=""
              />
              <div class="p-6 c-20-t abs .b .s">
                <div class="o-5">MORE</div>
                <div style="font-size: 30px; font-weight: bold" class="o-9">
                  — EXPLORE
                </div>
              </div>
            </a>
          </div>
        </SwpWidget>
      </section>

      <footer class="m-t-7 w-f --ltr c-s rlt" style="color: white">
        <img
          src="@/assets/SVG/paint-x.svg"
          class="abs .b-f w-f -z -pe-n"
          style="margin: -3px 0"
        />
        <div class="p-5">
          <div class="g">
            <div class="x12 l:x6 p-5">
              <h3 class="CASE t-w9">INFORMATION</h3>
              <div style="opacity: 0.7; font-size: 20px">
                Production de 40k tonnes par an Plus de 100k teintes réalisables
                une maitrise totale de nos livraisons Une gamme de produits
                complète pour le bâtiment Des conseils techmique pertinents
              </div>
              <div class="ln m-y-5"></div>
              <details>
                <summary class="CASE">
                  Who we are?
                </summary>
                <p style="opacity: 0.7; font-size: 20px">
                  L’entreprise eurl Roumani Color , spécialisée dans le domaine
                  de fabrication de peinture et dérives a été créée en 2007 par
                  Mr Roumani Abdelhakim jeune algérien ne en 1972 son fondateur
                  et actuel gérant Cette entreprise a démarré avec un petit
                  mélangeur de matière première pour fabrication de peinture a
                  base de vinyle dune capacité de six tonne jour dans un petit
                  hangar dune superficie ne dépassant pas 150m ne comptant qu’un
                  personnel réduit qui ne dépassait pas cinq ouvriers que
                  cadrait le jeune gérant . Avec le travail acharne et la
                  volonté de cette équipe , EURL ROUMANI COLOR emploi
                  actuellement plus dune soixante d’ouvrier (production et
                  administration ) soixante familles se nourrissant de cette
                  dernière . L’EURL ROUMANI COLLOR est implantée actuellement
                  sur une superficie de 2080 m Et a procédé a l’acquisition de
                  six machine au cours des annes 2008 2009et 2010 qui peuvent
                  atteindre une production journalière de plus 20 tonnes entre
                  peinture vernis et poudre ainsi quine seul nouvelle gamme de
                  peinture SATINEE , mise sur le marche récemment . Son parc
                  roulant récent compte huit véhicule livrant quotidiennement la
                  marchandise a travers toutes les wilayas du centre
                </p>
              </details>
              <details>
                <summary class="CASE">
                  owr values?
                </summary>
              <ul style="opacity: 0.7; font-size: 20px">
                <li>Une politique de prix compétitive</li>
                <li>Une réactivité immédiate</li>
                <li>Une implication exemplaire de chaque service</li>
                <li>Une tequnicite reconnue sur le marche de la peinture</li>
              </ul>
              </details>
            </div>
            <div class="x12 l:x3 p-5">
              <h3 class="CASE t-w9">contact us</h3>
              <div class="b-cl">
                <a class="unt h-10 -r-3" href="tel:0560364030"
                  ><div class="u-10 b-fs -i">smartphone</div>
                  <span class="b-fg"
                    ><div>Phone</div>
                    <div style="font-size: 14px">
                      +(213) 0560.36.40.30
                    </div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div
                ></a>
                <a class="unt h-10 -r-3" href="tel:025376828"
                  ><div class="u-10 b-fs -i">call</div>
                  <span class="b-fg"
                    ><div>Fix</div>
                    <div style="font-size: 14px">+(213) 025.37.68.28</div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div
                ></a>
                <address class="p-5 -r-3 m-t-4 t-btn rlt t-s-n"><div class="CASE o-5">address:</div> w62, Aïn Romana, blida (Algeria)<div class="-bg c-w o-1"></div></address>
              </div>
              <h3 class="CASE t-w9">help</h3>
              <div style="opacity: 0.7">
                for more INFORMATIONs please contact us.
              </div>
            </div>
            <div class="x12 l:x3 p-5">
              <h3 class="CASE t-w9">FOLLOW US</h3>
              <div class="b-cl">
                <a href="tel:0560364030" class="unt h-9 -r-3 CASE"
                  ><div
                    class="u-10 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/whatsapp.svg') + ')',
                    }"
                  ></div>
                  <span class="b-fg t-b1 p-t-2"
                    >whatsapp
                    <div class="t-c o-5">Contact us</div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div></a
                ><a
                  target="_blank"
                  class="unt h-9 -r-3 CASE"
                  href="https://www.facebook.com/StarPeintureRoumani/"
                  ><div
                    class="u-10 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/facebook.svg') + ')',
                    }"
                  ></div>
                  <span class="b-fg t-b1 p-t-2"
                    >facebook
                    <div class="t-c o-5">Follow us</div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div
                ></a>
                <a
                  href="https://www.instagram.com/star_peinture/"
                  target="_blank"
                  class="unt h-9 -r-3 CASE"
                  ><div
                    class="u-10 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/instagram.svg') + ')',
                    }"
                  ></div>
                  <span class="b-fg t-b1 p-t-2"
                    >instagram
                    <div class="t-c o-5">Follow us</div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div
                ></a>
                <a
                  href="https://www.messenger.com/t/1558616247543701"
                  target="_blank"
                  class="unt h-9 -r-3 CASE"
                  ><div
                    class="u-10 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/messenger.svg') + ')',
                    }"
                  ></div>
                  <span class="b-fg t-b1 p-t-2"
                    >messenger
                    <div class="t-c o-5">Follow us</div></span
                  >
                  <div
                    class="u-10 o-5 b-fs -i-bg"
                    :style="{
                      backgroundImage:
                        'url(' + require('@/assets/SVG/open.svg') + ')',
                    }"
                  ></div
                ></a>
              </div>
            </div>
          </div>
        </div>
        <div class="ln"></div>
        <div class="m:x10 l:x8 m-x-a p-y-6 p-x-4">
          <div>
            <p class="p-n" translate="no">STARPEINTURE</p>
            <div class="b b-j-sb b-a-c">
              <div class="t-c o-8">
                All rights reserved, STAR-PEINTURE ©{{
                  new Date().getFullYear()
                }}.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </div>
    <!--v-if-->
  </div>
  <!-- <div class="--env --rtl --light"> -->
  <!-- <div class="d20 l19 c0-t"> -->
  <!-- <section class="h-vh g rlt"> -->

  <!-- </section> -->
  <!-- </div> -->
  <!-- <div v-if="loading" class="fxd .f -z"> -->
  <!-- <LoadingWidget></LoadingWidget> -->
  <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import SwpWidget from './widgets/kimai/Swp'
import CateCard from './widgets/cates/CateCard'
import ProductCard from './widgets/products/ProductCard'
// const axios = require('axios')
class Pops {
  constructor () {
    this.leafs = []
    this._init()
  }

  _init () {
    this.rootElement =
      document.querySelector('#pops-root') || document.createElement('div')
    this.rootElement.setAttribute('id', 'pops-root')
    this.rootElement.style.setProperty('max-width', '100%')
    this.rootElement.style.setProperty('overflow-y', 'auto')
    this.rootElement.style.setProperty('max-height', '100vh')
    // this.rootElement.style.setProperty("pointer-events", "none");
    this.rootElement.classList.add('fxd', '-z-3', '.t', '.e', 'p-4')
    document.body.appendChild(this.rootElement)
  }

  show (message, color = 'rgb(255, 203, 0)') {
    const leaf = document.createElement('div')
    leaf.classList.add('m-b-4', 'p-x-6', 'p-y-5', '-r-3', 'e', 'c-ylw')
    leaf.style.setProperty('--c-ylw', color)
    // leaf.style.setProperty("pointer-events", "all");
    leaf.innerHTML = message
    this.leafs.unshift(leaf)
    this.rootElement.appendChild(leaf)

    leaf.addEventListener('click', () => {
      leaf.remove()
    })
    return leaf
  }
}
window.pops = new Pops()

export default {
  data () {
    return {
      activeSideImageId: 1,
      isMenuOpen: false,
      isPageReady: false
    }
  },
  components: {
    SwpWidget,
    CateCard,
    ProductCard
  },
  computed: {
    ...mapState(['loading'])
  },
  watch: {
    // $route (to, from) {
    // this.$store.commit('config', to.query)
    // },

    '$store.state.theme.brightness': function (to) {
      var root = document.querySelector('.--env')
      localStorage.theme = to
      if (to === 'dark') {
        root.classList.add('--dark')
        root.classList.remove('--light')
      } else {
        root.classList.add('--light')
        root.classList.remove('--dark')
      }
    }
  },
  created () {
    // this.$store.dispatch("loadBData");
    console.log(this.$route)
    window.onload = () => {
      this.isPageReady = true
    }
  },
  methods: {
    ...mapMutations(['TOGGLE_SIDEBAR'])
  },
  mounted () {
    setInterval(() => {
      if (this.activeSideImageId === 4) {
        this.activeSideImageId = 0
      }
      this.activeSideImageId++
    }, 4000)
  }
}
</script>

<style lang="scss">
@import "../../../../../../opensource/web/kimai/src/sass/import.scss";
@import url("https://fonts.googleapis.com/css2?family=Josefin+Sans:wght@400;600&display=swap");
#wonder:hover {
  background-color: #222 !important;
}
.scale-down-on-hover:hover {
  transform: scale(0.95);
}
[data-ready="false"] .loading-box {
  width: 100vw;
}
[data-ready="true"] .loading-box {
  width: 56px;
}
// sub
.subtitle {
  background-size: contain;
  font-size: 32px;
}

//logo

[data-ready="true"] .logo-box {
  top: 0%;
  left: 0%;
  width: 56px;
  height: 56px;
  transform: translate(0%, 0%);
}
[data-ready="false"] .logo-box {
  top: 50%;
  left: 50%;
  width: 200px;
  height: 200px;
  transform: translate(-50%, -50%);
}
// menu-box
.menu-box {
  max-width: 100vw;
}
[data-open-menu="true"] .menu-box {
  width: 300px;
}
[data-open-menu="false"] .menu-box {
  width: 56px;
}

// [data-ready="false"] .menu-box {
// opacity: 0;
// visibility: hidden;
// }
//
html {
  font-family: "Josefin Sans";
}

.--env {
  --theme-font-edit-size: 0px;
  font-size: 20px;
}

.--dark {
  --c-s: #030031;
  --c-p: rgb(255, 188, 0);
}

.--light {
  --c-s: rgb(3, 0, 49);
  --c-p: rgb(255, 188, 0);
}

@media only screen and (max-width: 839px) {
  #sidebar {
    position: absolute;
    top: 0;
    transform: translateY(-100%);
    z-index: 9999;
    height: 100vh;
  }

  #sidebar.show {
    transform: translateX(0%);
  }
}
</style>
